import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CardVisitaAll from '../CardVisitaAll/CardVisitaAll';
import style from './CardVisitasAllContainer.module.css';

const CardVisitasAllContainer = () => {
  const [visitas, setVisitas] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filtroTipo, setFiltroTipo] = useState('todas');
  const [totals, setTotals] = useState({ total: 0, internas: 0, externas: 0 });

  useEffect(() => {
    const fetchVisitas = async () => {
      try {
        const response = await axios.get(`/visitas`);
        const raw = response.data;

        // El endpoint ahora puede devolver { visitas: [...], total, totalInternas, totalExternas }
        const data = Array.isArray(raw) ? raw : (raw.visitas || []);

        if (!Array.isArray(raw)) {
          setTotals({
            total: raw.total || data.length,
            internas: raw.totalInternas || data.filter(v => v.tipo !== 'externa').length,
            externas: raw.totalExternas || data.filter(v => v.tipo === 'externa').length
          });
        } else {
          setTotals({ total: data.length, internas: data.length, externas: 0 });
        }
  
        // Agrupar visitas por fecha sin desajuste de zona horaria
        const groupedVisitas = data.reduce((acc, visita) => {
          const [year, month, day] = visita.fecha.split('-');
          const fechaFormateada = `${day}/${month}/${year}`;
          if (!acc[fechaFormateada]) acc[fechaFormateada] = [];
          acc[fechaFormateada].push(visita);
          return acc;
        }, {});
  
        setVisitas(groupedVisitas);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
  
    fetchVisitas();
  }, []);

  const filteredVisitas = Object.entries(visitas).reduce((acc, [fecha, visitasPorFecha]) => {
    const filtered = visitasPorFecha.filter(v => {
      if (filtroTipo === 'internas') return v.tipo !== 'externa';
      if (filtroTipo === 'externas') return v.tipo === 'externa';
      return true;
    });
    if (filtered.length > 0) acc[fecha] = filtered;
    return acc;
  }, {});
  
  return (
    <div className={style.container}>
      {/* Filtros y totales */}
      <div className={style.filterBar}>
        <div className={style.totalsRow}>
          <span className={style.totalBadge}>Total: {totals.total}</span>
          <span className={style.totalBadgeInternas}>Internas: {totals.internas}</span>
          <span className={style.totalBadgeExternas}>Externas: {totals.externas}</span>
        </div>
        <div className={style.filterButtons}>
          {['todas', 'internas', 'externas'].map(tipo => (
            <button
              key={tipo}
              className={`${style.filterBtn} ${filtroTipo === tipo ? style.filterBtnActive : ''}`}
              onClick={() => setFiltroTipo(tipo)}
            >
              {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {loading && <p>Cargando visitas...</p>}
      {error && <p>Error: {error}</p>}
      {Object.keys(filteredVisitas).length > 0 ? (
        Object.entries(filteredVisitas).map(([fecha, visitasPorFecha]) => (
          <div key={fecha} className={style.dateGroup}>
            <h1 className={style.dateHeader}>{fecha}</h1>
            <div className={style.cardContainer}>
              {Array.isArray(visitasPorFecha) ? (
                visitasPorFecha.map((visita) => (
                  <CardVisitaAll key={`${visita.tipo || 'int'}-${visita.id}`} visita={visita} />
                ))
              ) : (
                <p>Error: No hay visitas para esta fecha.</p>
              )}
            </div>
          </div>
        ))
      ) : (
        !loading && <p>No hay visitas registradas.</p>
      )}
    </div>
  );
};

export default CardVisitasAllContainer;
